var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewingMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.81 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    x: 3.87,
    y: 11.58,
    width: 9.1,
    height: 1.89
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    x: 3.87,
    y: 15.76,
    width: 3.96,
    height: 1.89
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    d: "m24.66,18.8c-.09-.22-2.17-5.1-7.36-5.46v-5.59L9.54,0H0v21.91h10.25c1.57,1.95,3.94,3.09,6.45,3.09,5.63,0,7.87-5.26,7.96-5.48l.15-.36-.15-.36Zm-7.96,4.31c-1.33,0-2.63-.41-3.7-1.2-.71-.52-1.33-1.16-1.82-1.89-.19-.28-.37-.56-.52-.86.95-1.91,2.69-3.31,4.75-3.82.42-.09.86-.13,1.29-.13.21,0,.41,0,.6.03,2.36.32,4.4,1.79,5.44,3.92-1.12,2.34-3.45,3.86-6.04,3.95M10.14,3.27l3.62,3.62h-3.62v-3.62ZM1.89,20.02V1.89h6.35v6.89h7.16v4.63c-4.69.71-6.59,5.18-6.68,5.38l-.15.36.15.36s.09.22.24.5H1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    d: "m17.3,16.01c-.2-.04-.4-.06-.6-.06-1.68,0-3.03,1.36-3.03,3.04,0,1.68,1.36,3.03,3.04,3.03,1.68,0,3.03-1.36,3.03-3.04,0-1.44-1.02-2.69-2.44-2.97m0,3.95c-.54.33-1.24.16-1.57-.37-.33-.54-.16-1.24.37-1.57s1.24-.16,1.57.37c.11.18.17.39.17.6,0,.4-.21.76-.54.97"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewingMode);
export default __webpack_public_path__ + "static/media/viewingMode.935cbec22dc52d8c1709b9d95c764d61.svg";
export { ForwardRef as ReactComponent };